/*
  Shift modular sections · light states (<sr-led>)
  Each state owns a clip. Selecting a state (click, tap or arrow keys) shows that
  state's clip and plays it from the start; the other clips are hidden and paused.
  Nothing advances on its own. Autoplay and the pause button come from
  sr-media.js; with reduced motion a selection only swaps the poster, it doesn't play.
*/
(function () {
  if (customElements.get('sr-led')) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class SRLed extends HTMLElement {
    connectedCallback() {
      var self = this;
      var clips = Array.from(this.querySelectorAll('[data-sr-led-clip]'));
      this.states = Array.from(this.querySelectorAll('[data-sr-led-state]')).map(function (li, index) {
        return {
          el: li,
          btn: li.querySelector('.sr-led__btn'),
          desc: self.querySelector('[data-sr-led-desc="' + index + '"]'),
          clip: clips[index] || null
        };
      });
      if (!this.states.length) return;

      this.index = 0;
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.states.forEach(function (state, index) {
        if (!state.btn) return;
        state.btn.addEventListener('click', function () { self.go(index); });
        state.btn.addEventListener('keydown', function (event) { self.onKey(event, index); });
        state.btn.addEventListener('focus', function () { self.reveal(state.el); });
      });

      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    slotOf(state) {
      return state.clip ? state.clip.querySelector('[data-sr-video]') : null;
    }

    select(index) {
      var self = this;
      var changed = index !== this.index;
      this.index = index;
      this.states.forEach(function (state, i) {
        var on = i === index;
        state.el.classList.toggle('is-active', on);
        if (state.btn) state.btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (state.desc) state.desc.classList.toggle('is-active', on);
        if (!state.clip) return;
        var slot = self.slotOf(state);
        if (!on) {
          if (slot && window.SRMedia) window.SRMedia.pause(slot);
          state.clip.hidden = true;
          state.clip.classList.remove('is-active');
          return;
        }
        state.clip.hidden = false;
        state.clip.classList.add('is-active');
        // Each state's clip starts from its first frame when it is selected
        if (changed && slot) {
          slot.querySelectorAll('video').forEach(function (v) {
            try { v.currentTime = 0; } catch (e) {}
          });
        }
      });
      // Keep the active pill in view on mobile, unless keyboard focus is on another pill
      var pill = this.states[index].el;
      var list = pill.parentElement;
      if (list && list.contains(document.activeElement) && !pill.contains(document.activeElement)) return;
      this.reveal(pill);
    }

    reveal(pill) {
      var list = pill.parentElement;
      if (!list || list.scrollWidth <= list.clientWidth) return;
      var left = pill.offsetLeft - list.offsetLeft;
      if (left < list.scrollLeft || left + pill.offsetWidth > list.scrollLeft + list.clientWidth) {
        list.scrollTo({ left: Math.max(left - 4, 0), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
    }

    go(index) {
      this.select(index);
      if (reduceMotion.matches) return;
      var slot = this.slotOf(this.states[index]);
      if (!slot) return;
      slot.removeAttribute('data-user-paused');
      if (window.SRMedia) window.SRMedia.play(slot);
    }

    onKey(event, index) {
      var last = this.states.length - 1;
      var next = null;
      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          next = index === last ? 0 : index + 1;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          next = index === 0 ? last : index - 1;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = last;
          break;
        default:
          return;
      }
      event.preventDefault();
      if (this.states[next].btn) this.states[next].btn.focus();
      this.go(next);
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) return;
      var index = this.states.findIndex(function (s) { return s.el === event.target; });
      if (index > -1) this.go(index);
    }
  }

  customElements.define('sr-led', SRLed);
})();
